import Modal, { ModalContent } from "../../elements/Modal";
import { PayoutReceiptLegacy, formatCurrency } from "../../../pages/Restaurants/Finance/data";

const Receipt = ({
  payout,
  toggleModal,
}: {
  payout: PayoutReceiptLegacy;
  toggleModal: () => void;
}) => {
  return (
    <Modal
      open={true}
      onClose={toggleModal}
      className="flex items-center justify-center"
    >
      <ModalContent className="mx-3 p-6 rounded-md shadow-lg flex flex-col  bg-white w-[80%] md:w-[45%] lg:w-[40%] xl:w-[50%] font-mont">
        <h1 className="font-semibold text-2xl text-secondary pb-2">
          Payout Receipt
        </h1>
        <p className="text-gray-500 pb-4">
          View the details of this payout to the Restaurant
        </p>
        <section className="h-[30rem] overflow-y-auto p-2">
          <section className="mt-5 mb-10">
            <h2 className="text-lg font-semibold">Vendor Details</h2>
            <hr className="my-2" />
            <article className="flex justify-between items-center gap-10">
              <div className="w-1/2 my-2 py-2 border-b">
                <h3 className="text-gray-500 font-medium">Restaurant Name:</h3>
                <p className="text-lg my-1">{payout.vendorDetails.name}</p>
              </div>
              <div className="w-1/2 my-2 py-2 border-b">
                <h3 className="text-gray-500 font-medium">Restaurant ID:</h3>
                <p className="text-lg my-1">{payout.vendorDetails.id}</p>
              </div>
            </article>
            <article className="flex justify-between items-center gap-10">
              <div className="w-1/2 my-2 py-2 border-b">
                <h3 className="text-gray-500 font-medium">
                  Restaurant Contact Phone:
                </h3>
                <p className="text-lg my-1">{payout.vendorDetails.phone}</p>
              </div>
              <div className="w-1/2 my-2 py-2 border-b">
                <h3 className="text-gray-500 font-medium">
                  Restaurant Contact Email:
                </h3>
                <p className="text-lg my-1">{payout.vendorDetails.email}</p>
              </div>
            </article>
          </section>
          <section className="my-10">
            <h2 className="text-lg font-semibold">Payout Information</h2>
            <hr className="my-2" />
            <article className="flex justify-between items-center gap-10">
              <div className="w-1/2 my-2 py-2 border-b">
                <h3 className="text-gray-500 font-medium">Payout Amount:</h3>
                <p className="text-lg my-1">{formatCurrency(parseInt(payout.payoutInfo.amount) || 0)}</p>
              </div>
              <div className="w-1/2 my-2 py-2 border-b">
                <h3 className="text-gray-500 font-medium">Payout Date:</h3>
                <p className="text-lg my-1">{payout.payoutInfo.date}</p>
              </div>
            </article>
            <article className="flex justify-between items-center gap-10">
              <div className="w-1/2 my-2 py-2 border-b">
                <h3 className="text-gray-500 font-medium">Account Bank:</h3>
                <p className="text-lg my-1">{payout.payoutInfo.bankName}</p>
              </div>
              <div className="w-1/2 my-2 py-2 border-b">
                <h3 className="text-gray-500 font-medium">Account Number:</h3>
                <p className="text-lg my-1">
                  {payout.payoutInfo.accountNumber}
                </p>
              </div>
            </article>
          </section>
          <section className="my-10">
            <h2 className="text-lg font-semibold mb-5">
              Earnings and Deduction
            </h2>
            <table className="w-full">
              <thead className="text-left border-y">
                <tr>
                  <th className="py-3 font-medium">Description</th>
                  <th className="py-3 font-medium">Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-y">
                  <td className="py-3">Total Earnings</td>
                  <td className="py-3">{formatCurrency(parseInt(payout.totalEarnings) || 0)}</td>
                </tr>
                <tr className="border-y">
                  <td className="py-3">Deduction (Fee)</td>
                  <td className="py-3">{formatCurrency(parseInt(payout.deduction) || 0)}</td>
                </tr>
                <tr className="border-y">
                  <td className="py-3">Net Payout</td>
                  <td className="py-3">{formatCurrency(parseInt(payout.netPayout) || 0)}</td>
                </tr>
              </tbody>
            </table>
          </section>
        </section>
      </ModalContent>
    </Modal>
  );
};

export default Receipt;
